import styled from 'styled-components';
import { rgba } from 'polished';

// COLORS
import { WHITE, SUPERNOVA, BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';
import { getS3ImageUrl } from '@/utility/content';

const bg = getS3ImageUrl('/banners/banner-sling-bg.png');
const bgMob = getS3ImageUrl('/banners/banner-sling-bg-mob.png');

export const Container = styled.div`
  position: relative;
  padding: 32px 30px;
  border-radius: 8px;
  background: ${WHITE};
  overflow: hidden;

  .banner-app {
    &__title {
      font-size: 3.2rem;
      font-weight: 400;
      margin-bottom: 25px;

      img {
        display: inline-block;
        max-width: 120px;
        vertical-align: middle;
        margin-bottom: 8px;
      }

      a {
        font-size: 3.2rem;
        font-weight: 400;
      }

      ${breakpoints.down('sm')} {
        font-size: 2.8rem;

        img {
          max-width: 96px;
        }

        a {
          font-size: 2.8rem;
        }
      }

      ${breakpoints.down('xs')} {
        font-size: 2.4rem;

        img {
          max-width: 80px;
        }

        a {
          font-size: 2.4rem;
        }
      }
    }

    &__btn {
      min-width: 240px;
    }

    &__channels-img {
      max-width: 100%;
    }

    &__price {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    &__section-right {
      position: relative;
      z-index: 1;

      &::before {
        content: '';
        position: absolute;
        top: -20px;
        right: -23px;
        width: calc(100% + 23px);
        height: calc(100% + 40px);
        background: url(${bg}) no-repeat center left;
        z-index: -1;
        background-size: cover;

        ${breakpoints.down('xs')} {
          top: 0;
          right: -23px;
          left: -23px;
          width: calc(100% + 63px);
          background-image: url(${bgMob});
        }
      }
    }
  }

  .pros-cons-list {
    margin-bottom: 15px;

    li:not(:last-of-type) {
      margin-bottom: 12px;
    }
  }

  .channels {
    margin-bottom: 30px;
    display: flex;

    &__item {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${WHITE};
      border-radius: 50%;
      width: 38px;
      height: 38px;
      padding: 8px;
      box-shadow: 0 0 12px 0 ${rgba(BLACK, 0.1)};

      &:not(:last-of-type) {
        margin-right: 8px;
      }
    }

    &__icon {
      width: 100%;
      height: auto;
      position: relative;
    }
  }

  .price {
    color: ${WHITE};

    &__block {
      display: flex;
      align-items: center;

      ${breakpoints.down('sm')} {
        flex-wrap: wrap;
        justify-content: flex-end;
      }
    }

    &__text {
      ${breakpoints.down('xs')} {
        font-size: 1.5rem;
      }
    }

    &__old-price {
      font-size: 2.8rem;
      font-weight: 600;
      margin-right: 5px;

      ${breakpoints.down('xs')} {
        font-size: 2rem;
      }
    }

    &__new-price {
      font-size: 4rem;
      line-height: 4.4rem;
      font-weight: 600;
      color: ${SUPERNOVA};

      ${breakpoints.down('xs')} {
        font-size: 3rem;
        line-height: 3.5rem;
      }
    }
  }
`;

export default Container;
